import { render, staticRenderFns } from "./DispensingUnit.vue?vue&type=template&id=bfeada5e&"
import script from "./DispensingUnit.vue?vue&type=script&lang=js&"
export * from "./DispensingUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfeada5e')) {
      api.createRecord('bfeada5e', component.options)
    } else {
      api.reload('bfeada5e', component.options)
    }
    module.hot.accept("./DispensingUnit.vue?vue&type=template&id=bfeada5e&", function () {
      api.rerender('bfeada5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Aggregation/DispensingUnit.vue"
export default component.exports